export enum RouteQueryParamSourceApp {
  Admin = '31bcbca9-170d-443b-ba02-58752caef45b',
  Shop = '357a456a-07aa-4b66-bb2b-9ed9df88c7de',
}
